import { Suspense } from "react";

import { graphql, useLazyLoadQuery } from "react-relay";

import { GroupsDirectory } from "app/components/rbac/GroupsDirectory";
import { TableSkeleton } from "app/components/skeletons";

import { SettingsTabsLayout } from "../SettingsTabsLayout";
import { type GroupsSettingsRootQuery } from "./__generated__/GroupsSettingsRootQuery.graphql";
import { AccessControlSettingsPage } from "./AccessControlSettingsPage";
import { GroupsActionBar } from "./GroupsActionBar";

export function GroupsSettingsRoot() {
  const data = useLazyLoadQuery<GroupsSettingsRootQuery>(
    graphql`
      query GroupsSettingsRootQuery {
        ...AccessControlSettingsPage_query
      }
    `,
    {},
  );

  return (
    <AccessControlSettingsPage pageTitle="Groups" queryRef={data}>
      <SettingsTabsLayout>
        <div className="flex w-full flex-col">
          <GroupsActionBar />

          <Suspense fallback={<TableSkeleton size="medium" />}>
            <GroupsDirectory />
          </Suspense>
        </div>
      </SettingsTabsLayout>
    </AccessControlSettingsPage>
  );
}
